var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopupStriked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_326_1697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2H7.979C6.88 2 6 2.88 6 3.98V12C6 13.1 6.9 14 8 14H16C17.1 14 18 13.1 18 12V4C18 2.9 17.1 2 16 2ZM16 12H8V4H16V12ZM4 10H2V16C2 17.1 2.9 18 4 18H10V16H4V10Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.70711,
    y1: 0.292893,
    x2: 19.7071,
    y2: 16.2929,
    stroke: "#7E8794",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.41421,
    y1: 2,
    x2: 18,
    y2: 16.5858,
    stroke: "#DCDEE2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_326_1697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupStriked);
export default __webpack_public_path__ + "static/media/popup-striked.95abf47d8d5c5060be5ded7d17eb6193.svg";
export { ForwardRef as ReactComponent };